// extracted by mini-css-extract-plugin
export default {"header":"Error_header__1THRJ"};